const conditions = () => {
  return [{ assetClass: { $ne: '' } }]
}

export default conditions
